<template>
  <base-card tabled>
    <template v-slot:header>
      <base-card-heading>Borrower Details</base-card-heading>
      <div v-if="$auth.admin()">
        <base-button class="mr-1" secondary small :to="{ name: 'users.dashboard', params: { id: project.user._id } }">
          View
        </base-button>
        <base-button secondary small @click="$modal.show('#projectChangeBorrower')">
          Change
        </base-button>
      </div>
    </template>
    <base-table>
      <colgroup>
        <col width="115" />
      </colgroup>
      <tbody>
        <tr>
          <th>Borrower</th>
          <td>{{ project.user.profile.firstName }} {{ project.user.profile.lastName }}</td>
        </tr>
        <tr>
          <th>Phone</th>
          <td>
            <a :href="`tel:${project.user.profile.phone}`">
              {{ project.user.profile.phone }}
            </a>
          </td>
        </tr>
        <tr>
          <th>Email</th>
          <td class="text-truncate">
            <a :href="`mailto:${project.user.email}`">{{ project.user.email }}</a>
          </td>
        </tr>
        <tr>
          <th>Address</th>
          <td>
            <formatted-address :address="project.user.profile.address"/>
          </td>
        </tr>
      </tbody>
    </base-table>
    <project-change-borrower />
  </base-card>
</template>

<script>
import { mapState } from 'vuex'

import FormattedAddress from './FormattedAddress.vue'
import ProjectChangeBorrower from './ProjectChangeBorrower.vue'

export default {
  name: 'ProjectBorrowerCard',

  components: {
    FormattedAddress,
    ProjectChangeBorrower
  },

  computed: mapState({
    project: store => store.core.projects.entity
  })
}
</script>
